import { render, staticRenderFns } from "./orgTreePage.vue?vue&type=template&id=ecf04e4c&scoped=true&"
import script from "./orgTreePage.vue?vue&type=script&lang=js&"
export * from "./orgTreePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf04e4c",
  null
  
)

export default component.exports